import { useLocation } from "react-router-dom";

import * as Routes from "../../shared/Routes";
import { UserMode, useUserMode } from "../lib/UserMode";
import { useSellerOrgUnifiedInbox } from "./useTeacherUnifiedMessaging";

export function useConversationsPath() {
  const userMode = useUserMode();
  const isSellerOrgUnifiedInbox = useSellerOrgUnifiedInbox();
  return Routes.conversationsPath(
    isSellerOrgUnifiedInbox ? UserMode.Educator : userMode,
  );
}

/**
 * Query params for a thread's "back to inbox" link: the inbox query the thread
 * was opened from, or the thread URL's selected org teacher.
 */
export function useConversationInboxBackQueryParams():
  | Record<string, string>
  | undefined {
  const location = useLocation<any>();
  const viewAsOrgTeacherUid = location.query?.viewAsOrgTeacherUid;
  return (
    location.state?.prevConversationQueryParams ??
    (viewAsOrgTeacherUid ? { viewAsOrgTeacherUid } : undefined)
  );
}
